import React from 'react';
import { useShop } from '../context/ShopContext';

export const Footer: React.FC = () => {
  const { t, setLegalModalType } = useShop();

  return (
    <footer className="bg-neutral-950 text-gray-400 text-xs border-t border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Brand info */}
          <div className="space-y-1 text-center md:text-left">
            <span className="font-display text-lg font-bold text-white tracking-tight">
              {t.nav.brand}
            </span>
            <p className="text-gray-500 max-w-sm">
              {t.footer.discreetMug}
            </p>
          </div>

          {/* Legal Navigation Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs">
            <button
              onClick={() => setLegalModalType('cgv')}
              className="hover:text-white transition-colors"
            >
              {t.footer.terms}
            </button>
            <button
              onClick={() => setLegalModalType('privacy')}
              className="hover:text-white transition-colors"
            >
              {t.footer.privacy}
            </button>
            <button
              onClick={() => setLegalModalType('cookies')}
              className="hover:text-white transition-colors"
            >
              {t.footer.cookies}
            </button>
            <button
              onClick={() => setLegalModalType('shipping')}
              className="hover:text-white transition-colors"
            >
              {t.footer.shippingPolicy}
            </button>
            <button
              onClick={() => setLegalModalType('withdrawal')}
              className="hover:text-white transition-colors"
            >
              {t.footer.withdrawal}
            </button>
            <button
              onClick={() => setLegalModalType('legal')}
              className="hover:text-white transition-colors"
            >
              {t.footer.legalNotice}
            </button>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-neutral-900 flex flex-col sm:flex-row justify-between items-center gap-4 text-gray-600 text-[11px]">
          <p>© {new Date().getFullYear()} {t.nav.brand}. {t.footer.rights}</p>
          <p className="flex items-center gap-2">
            <span>Suisse & Europe</span>
            <span>•</span>
            <span>Paiement certifié Stripe</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
